import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from '../../../services/subscription.service';
import { ChangeCollectionTypeService } from '../../../services/change-collection-type.service';
import { ModalService } from '../../../services/modals.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';
import { openModal, closeModal, closeModalWithoutRemovingBackdrop } from '../../../shared/modal-functions';
import { responseIsSuccess } from '../../../shared/helper-functions';
import { arrayIsDefinedAndContainsKey } from '../../../shared/array-functions';
import { getCurrentDateForView } from '../../../shared/date-functions';
import { subscriptionViewSpanish, changeCollectionTypeView } from '../subscription.static.data';

@Component({
  selector: 'app-change-collection-type',
  templateUrl: './change-collection-type.component.html',
  styleUrls: ['../../../app.component.css']
})
export class ChangeCollectionTypeComponent implements OnInit {
  // Static Data
  changeCollectionTypeView: any;
  currentDate: string;
  // Control view
  openModal: any;
  closeModal: any;
  closeModalWithoutRemovingBackdrop: any;
  transactionCompleted: boolean;
  // Response data
  responseTitle: string;
  responseBody: string;
  responseAction: string;

  constructor(public subscriptionService: SubscriptionService, public changeCollectionTypeService: ChangeCollectionTypeService, public modalService: ModalService, public googleAnalyticsService: GoogleAnalyticsService) { 
    this.changeCollectionTypeView = changeCollectionTypeView;
    this.openModal = openModal;
    this.closeModal = closeModal;
    this.closeModalWithoutRemovingBackdrop = closeModalWithoutRemovingBackdrop;
    this.transactionCompleted = true;
    this.currentDate = getCurrentDateForView();
  }

  ngOnInit() {
  }

  switchToEasyPay() {
    this.changeCollectionTypeService.paymentMethod['paymentTypeId'] === this.subscriptionService.atabexIdentifiers['creditCardId'] ? this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Acuerdo_Pago_Boton_Confirmar_Tarjeta_Credito') : this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Acuerdo_Pago_Boton_Confirmar_Cuenta_Banco');
    this.transactionCompleted = false;
    this.changeCollectionTypeService.switchToEasyPay(this.subscriptionService.customerId, this.subscriptionService.selectedSubscriptionId, this.subscriptionService.packageId, this.subscriptionService.creditPromotionsId).subscribe((response) => {
      if (responseIsSuccess(response) && arrayIsDefinedAndContainsKey(response, 'CMS_SAM_Put_CMS_SwitchToEasyPay') && response['CMS_SAM_Put_CMS_SwitchToEasyPay'][0]['SwitchToEasyPay']) {
        this.subscriptionService.getUpdatedSelectedSubscription();
        this.closeModal('#changeCollectionTypeModal');
        this.closeModal('#changeCollectionTypeConfirmationModal');
        this.openModal('#responseSubscriptionModal');
        this.responseTitle = changeCollectionTypeView.changeCollectionTypeToEasyPay.success.title;
        this.responseBody = changeCollectionTypeView.changeCollectionTypeToEasyPay.success.body;
        this.responseAction = changeCollectionTypeView.changeCollectionTypeToEasyPay.success.action;
        this.changeCollectionTypeService.paymentMethod['paymentTypeId'] === this.subscriptionService.atabexIdentifiers['creditCardId'] && !this.subscriptionService.selectedSubscription['ScheduledSwitch'] ? this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Pantalla_Confirmando_Acuerdo_Pago_Tarjeta_Credito_Sin_Alerta') : '';
        this.changeCollectionTypeService.paymentMethod['paymentTypeId'] === this.subscriptionService.atabexIdentifiers['bankAccountId'] && !this.subscriptionService.selectedSubscription['ScheduledSwitch'] ? this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Pantalla_Confirmando_Acuerdo_Pago_Cuenta_Banco_Sin_Alerta') : '';
        this.changeCollectionTypeService.paymentMethod['paymentTypeId'] === this.subscriptionService.atabexIdentifiers['creditCardId'] && this.subscriptionService.selectedSubscription['ScheduledSwitch'] ? this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Pantalla_Confirmando_Acuerdo_Pago_Tarjeta_Credito_Con_Alerta') : '';
        this.changeCollectionTypeService.paymentMethod['paymentTypeId'] === this.subscriptionService.atabexIdentifiers['bankAccountId'] && this.subscriptionService.selectedSubscription['ScheduledSwitch'] ? this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Pantalla_Confirmando_Acuerdo_Pago_Cuenta_Banco_Con_Alerta') : '';
      } else {
        this.closeModal('#changeCollectionTypeModal');
        this.closeModal('#changeCollectionTypeConfirmationModal');
        this.openModal('#responseSubscriptionModal');
        this.responseTitle = changeCollectionTypeView.changeCollectionTypeToEasyPay.error.title;
        this.responseBody = changeCollectionTypeView.changeCollectionTypeToEasyPay.error.body;
        this.responseAction = changeCollectionTypeView.changeCollectionTypeToEasyPay.error.action;
        this.changeCollectionTypeService.paymentMethod['paymentTypeId'] === this.subscriptionService.atabexIdentifiers['creditCardId'] ? this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Pantalla_Error_Acuerdo_Pago_Tarjeta_Credito') : '';
        this.changeCollectionTypeService.paymentMethod['paymentTypeId'] === this.subscriptionService.atabexIdentifiers['bankAccountId'] ? this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Pantalla_Error_Acuerdo_Pago_Cuenta_Banco') : '';
      }
      this.transactionCompleted = true;
    });
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/change-collection-type/change-collection-type.component.ts